<template>
  <div class="flow-card-group">
    <flow-card
      v-for="(card, index) in cards"
      :key="card.id"
      :ref="card.id"
      :card="card"
      :number="index"
      @click.native="onSelect($event, card.id)"
      v-click-outside="onClickOutside"
      :selected="card.id === selected"
    ></flow-card>
  </div>
</template>

<script>
import FlowCard from './FlowCard.vue';
import {ClickOutside} from '../../directives/ClickOutside';
export default {
  name: 'FlowCardGroup',
  components: {FlowCard},
  directives: {ClickOutside},
  props: {
    cards: {
      type: Array,
      required: true,
    },
    selected: {
      type: String,
    },
  },
  created() {
    this.cardSelected = this.selected;
  },
  methods: {
    onSelect(event, id) {
      event.stopPropagation();
      this.$emit('selected', id);
    },
    onClickOutside(e) {
      if (e.target.nodeName.toLowerCase() != 'button') this.$emit('selected', null);
    },
  },
};
</script>

<style lang="scss" scoped>
.flow-card-group {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 24px;
  margin: 30px 0;
}
</style>
